import * as types from "../actions/types";
/******************* 
@purpose : Intital home reducer data
@Author : INIC
******************/
const initialState = {
  isLoad: false,
  messages: [],
  modals: {
    login: false,
    register: false,
  },
  data: [],
  showMenu:false
};

/******************* 
@purpose : UI Reducer
@Parameter : {ini_data, action}
@Author : INIC
******************/
export default function home(ini_data = initialState, action = {}) {
  switch (action.type) {
    // Set Various Custom Redux Key Data /
    case types.SET_HOME_INFO:
      return Object.assign({}, ini_data, {
        data: action.data,
      });
      case types.SET_SHOW_MENU:
      return Object.assign({}, ini_data, {
        showMenu: action.data,
      });
      

    default:
      return ini_data;
  }
}
